import { useState, useEffect } from 'react';
import DateRangePickerWithShortcuts from '../../components/date-range-picker-with-shortcuts/date-range-picker-with-shortcuts';
import dayjs from 'dayjs';
import { ExportButtons } from '../../components/export-buttons';
import { PickerRangeValue } from '@mui/x-date-pickers/internals/models';

export function ReportContractLengthMenu({
  startDate,
  endDate,
  onDateChange,
  onExportExcel,
  exporting,
}: {
  startDate: Date | null;
  endDate: Date | null;
  onDateChange: (startDate: Date, endDate: Date) => void;
  onExportExcel: () => void;
  exporting?: boolean;
}) {
  const [start, setStartDate] = useState(startDate);
  const [end, setEndDate] = useState(endDate);
  useEffect(() => {
    setStartDate(startDate);
  }, [startDate]);
  useEffect(() => {
    setEndDate(endDate);
  }, [endDate]);
  useEffect(() => {
    if (start && end) onDateChange(start, end);
  }, [start, end]);

  return (
    <div className="flex gap-2 justify-between">
      <DateRangePickerWithShortcuts
        onChange={(value: PickerRangeValue) => {
          const nextStart = value?.[0]?.toDate();
          const nextEnd = value?.[1]?.toDate();
          if (nextStart && nextStart.getTime() !== start?.getTime()) {
            setStartDate(nextStart);
            setEndDate(null);
          }
          if (nextEnd && nextEnd.getTime() !== end?.getTime()) {
            setEndDate(nextEnd);
          }
        }}
        selectedDate={[dayjs(start), dayjs(end)]}
        calendars={2}
        shouldDisableDate={(date, position) =>
          start && position === 'end' ? date.isBefore(start) || date.isBefore(dayjs(start).add(1, 'month')) : false
        }
      />
      <ExportButtons onExportExcel={onExportExcel} loading={exporting} />
    </div>
  );
}
